export enum PayoutAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED',
}
